import { render, staticRenderFns } from "./BgLeaves.vue?vue&type=template&id=68729a5a"
import script from "./BgLeaves.vue?vue&type=script&lang=js"
export * from "./BgLeaves.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports